'use client'

// Spray cans — sprayPaint.glb, placement baked on the node (drops in at
// identity), lying by the dumpsters where he already scavenges.
//
// Deliberately NOT an activity. The sim carries them as scenery, so he
// can see them and say something about them, but there is nothing here
// to do: the studio arc opens with him finding paint in the rubbish
// rather than with a usable building appearing out of nowhere.
//
// Same material rebuild as Ruins: a fresh MeshStandardNodeMaterial with
// maps and params set EXPLICITLY (never copy(), which drops undefined
// into the node slots and kills the shader), so the cans light, shadow
// and run through RendererDither with the rest of the world.

import { useEffect } from 'react'
import * as THREE from 'three/webgpu'
import { useModel } from '../hooks/useModel'

const MODEL = '/models/sprayPaint.glb'

export function SprayPaint() {
  const { scene } = useModel(MODEL)

  useEffect(() => {
    const converted = new Map()
    scene.traverse((o) => {
      if (!o.isMesh) return
      o.castShadow = true
      o.receiveShadow = true
      const src = o.material
      if (!src || Array.isArray(src) || src.isNodeMaterial) return
      let nm = converted.get(src)
      if (!nm) {
        nm = new THREE.MeshStandardNodeMaterial()
        // the glTF carries its own base-colour texture; the loader has
        // already set colorSpace/flipY on it, so it just transfers
        if (src.map) nm.map = src.map
        nm.color = src.color?.clone() ?? new THREE.Color('white')
        nm.roughness = src.roughness ?? 0.9
        nm.metalness = src.metalness ?? 0
        nm.side = src.side
        nm.vertexColors = src.vertexColors
        converted.set(src, nm)
      }
      o.material = nm
    })
  }, [scene])

  // Transform is baked into the node — render at identity.
  return <primitive object={scene} />
}

export default SprayPaint
